import React from 'react'
import { Checkbox, CheckboxProps } from 'antd'
import { CustomText, CustomTitle } from 'src/components'
import type { CheckboxChangeEvent } from 'antd/es/checkbox'

interface CustomCheckBoxProps extends CheckboxProps {
  defaultValue: boolean,
  text: string,
  // eslint-disable-next-line no-unused-vars
  handleChange?: (value: boolean) => void
  disabled?: boolean
  isSmallText?: boolean
}

const CustomCheckBox: React.FC<CustomCheckBoxProps> = (props) => {
  const { defaultValue, text, handleChange = null, disabled = false, isSmallText = false, ...restProps } = props

  const handleOnChange = (e: CheckboxChangeEvent) => {
    if (handleChange) { handleChange(e.target.checked) }
  }

  return <Checkbox
    {...restProps}
    onChange={handleOnChange}
    checked={defaultValue}
    disabled={disabled}
  >
    {isSmallText ? <CustomText label={text} /> : <CustomTitle label={text} />}
  </Checkbox>

}
export default CustomCheckBox
